
import Input from '../utils/Input';
import Select from '../utils/Select';
import Brands from '../libs/API/Brands';
import Alert from './Alert';
import BrandCategorySelector from './BrandCategorySelector';
import Notification from './Notification';
import Organizations from '../libs/API/Organizations';
import Auth from '../libs/API/Auth';

const disallowedChars = ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '-', '_', '=', '+',
  '[', ']', '{', '}', '\\', '|', ';', ':', "'", '"', ',', '.', '<', '>',
  '/', '?', '`', '~'
];

class ModalNewClient {
  constructor (options) {
    this.main = document.getElementById('modal_new_client');
    this.modalCloseBtn = this.main.querySelector('.client-new-close-btn');
    this.cancelBtns = Array.from(this.main.querySelectorAll('.cancel-btn'));
    this.steps = Array.from(this.main.querySelectorAll('.step'));
    this.stepShowElements = Array.from(this.main.querySelectorAll('[data-step-show]'));
    this.autoReset = Boolean(options && options.autoreset);
    this.organizationsData = null;

    this._setupInputs();
    this._setupElements();
    this._initListeners();
    Auth.addEventListener('sessionReady', this._setOrganizationSelect.bind(this));

    this._sending = false;
    this._isOpen = false;
    this._id = null;
  }

  // Get the currently active step
  get activeStep() {
    const el = this.steps.find(step => !step.classList.contains('d-none'));
    return el ? el.dataset.step : null;
  }

  async _setOrganizationSelect(){
    if(!this._inputSelectCompany) this._inputSelectCompany = new Select( this.main.querySelector('select[name="business_select_company"]'), true);
    this.organizationsData = await Organizations.getOrganizations({ by_user: true, has_organization_customer: true });
    if(this.organizationsData){
      this._inputSelectCompany.items = this.organizationsData.map((item) => {
        return {
          value: item.id,
          text: item.name
        };
      });
    }
  }

  _setupInputs() {
    // Individual
    this._inputIndividualCompanyName = new Input(
      this.main.querySelector('input[name="individual_company_name"]'),
      { disallowedChars }
    );
    this._inputIndividualProductName = new Input(
      this.main.querySelector('input[name="individual_product_name"]'),
      { disallowedChars }
    );
    this._inputIndividualCategory = new BrandCategorySelector(
      this.main.querySelector('.brand-category-selector-individual')
    );
    this._inputIndividualCategory.actionButtonSize = 'medium';
    this._inputIndividualCategory.showIcon = false;
    this._inputIndividualFirstName = new Input(
      this.main.querySelector('input[name="individual_first_name"]')
    );
    this._inputIndividualLastName = new Input(
      this.main.querySelector('input[name="individual_last_name"]')
    );
    this._inputIndividualEmail = new Input(
      this.main.querySelector('input[name="individual_email"]')
    );
    this._inputIndividualTelephone = new Input(
      this.main.querySelector('input[name="individual_telephone"]')
    );
    this._inputIndividualTelephone.numeric = true;

    // Business
    this._inputEin = new Input(
      this.main.querySelector('input[name="business_ein"]'),
      { einPatter: true }
    );
    this._inputEin.numeric = true;
    this._inputCompanyName = new Input(
      this.main.querySelector('input[name="company_name"]'),
      { disallowedChars }
    );
    this._inputBusinessCompanyName = new Input(
      this.main.querySelector('input[name="business_company_name"]'),
      { disallowedChars }
    );
    this._selectBusinessType = new Select( this.main.querySelector('select[name="business_type"]'), true );
    this._inputBusinessFirstName = new Input(
      this.main.querySelector('input[name="business_first_name"]')
    );
    this._inputBusinessLastName = new Input(
      this.main.querySelector('input[name="business_last_name"]')
    );
    this._inputBusinessEmail = new Input(
      this.main.querySelector('input[name="business_email"]')
    );
    this._inputBusinessTelephone = new Input(
      this.main.querySelector('input[name="business_telephone"]')
    );
    this._inputBusinessTelephone.numeric = true;

    this._brandCategorySelectorCompany = new BrandCategorySelector(
      this.main.querySelector('.brand-category-selector-company')
    );
    this._brandCategorySelectorCompany.actionButtonSize = 'medium';
    this._brandCategorySelectorCompany.showIcon = false;
  }

  _setupElements() {
    this._submitBtnIndividual = this.main.querySelector('.btn_create_individual');
    this._submitBtnBusiness = this.main.querySelector('.btn_create_business');
    this._submitBtnBusinessBrand = this.main.querySelector('.btn_create_business_brand');
    this._headingActionTitle = this.main.querySelector('.heading_title .action-title');
  }

  _initListeners() {
    this.modalCloseBtn.addEventListener('click', e => {
      e.preventDefault();
      this.hide();
    });

    this.main.querySelector('.modal__content').addEventListener('click', e => {
      const btn = e.target.closest('[data-target-step]');
      if (!btn) return;
      e.preventDefault();
      const target = btn.dataset.targetStep;
      this._showStep(target);
    });

    this._submitBtnIndividual.addEventListener('click', this._onSubmit.bind(this));
    this._submitBtnBusiness.addEventListener('click', this._onSubmit.bind(this));
    this._submitBtnBusinessBrand.addEventListener('click', this._onSubmit.bind(this));

    this._selectBusinessType.addEventListener('brandCategoryChange', () =>
      this._selectBusinessType.select.main.closest('.form-group').classList.remove('form-group--error')
    );
    this._brandCategorySelectorCompany.addEventListener('brandCategoryChange', () =>
      this._brandCategorySelectorCompany.main.closest('.form-group').classList.remove('form-group--error')
    );
    this._inputIndividualCategory.addEventListener('brandCategoryChange', () =>
      this._inputIndividualCategory.main.closest('.form-group').classList.remove('form-group--error')
    );
  }

  _showStep(id) {
    this.steps.forEach(step => {
      const show = step.dataset.step === id;
      step.classList.toggle('d-none', !show);
      step.classList.toggle('d-block', show);
    });
    this.stepShowElements.forEach(el => {
      const show = el.dataset.stepShow === id;
      el.classList.toggle('d-none', !show);
    });
  }

  async show(values) {
    this._isOpen = true;
    if (this.autoReset) this._resetForm();

    this._headingActionTitle.textContent = values ? 'Edit' : 'Add new';
    const labelBtns = values ? 'Update' : 'Create';
    const submitButtons = [
      this._submitBtnIndividual,
      this._submitBtnBusiness,
      this._submitBtnBusinessBrand
    ];
    submitButtons.forEach(btn => {
      if (!btn) return;
      btn.querySelectorAll('.button__text').forEach(el => {
        el.textContent = labelBtns;
      });
    });

    if (values) {
      this._setForm(values);
      if (values.typeClient === 'individual') {
        this._showStep('individualForm');
      } else {
        const hasOrg = Boolean(values.organizationId);
        this._showStep(hasOrg ? 'businessFormExisting' : 'businessNewCompanyForm');
      }
      this.cancelBtns.forEach(b => b.classList.add('d-none'));
    } else {
      this._showStep('intro');
      this.cancelBtns.forEach(b => b.classList.remove('d-none'));
    }

    document.body.classList.add('block-scroll');
    this.main.classList.add('modal--show');
    setTimeout(() => this.main.classList.add('modal--anim'), 150);
  }

  hide() {
    this.main.classList.remove('modal--anim');
    setTimeout(() => {
      this.main.classList.remove('modal--show');
      document.body.classList.remove('block-scroll');
      this._isOpen = false;
      this._resetForm();
    }, 150);
  }

  _resetForm() {
    this._id = null;
    // Individual reset
    this._inputIndividualCompanyName.value = '';
    this._inputIndividualCompanyName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualProductName.value = '';
    this._inputIndividualProductName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualCategory.value = null;
    this._inputIndividualCategory.main.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualFirstName.value = '';
    this._inputIndividualFirstName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualLastName.value = '';
    this._inputIndividualLastName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualEmail.value = '';
    this._inputIndividualEmail.input.closest('.form-group').classList.remove('form-group--error');
    this._inputIndividualTelephone.value = '';
    this._inputIndividualTelephone.input.closest('.form-group').classList.remove('form-group--error');

    // Business reset
    this._inputBusinessCompanyName.value = '';
    this._inputBusinessCompanyName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputCompanyName.value = '';
    this._inputCompanyName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputEin.value = '';
    this._inputEin.input.closest('.form-group').classList.remove('form-group--error');
    if (this._selectBusinessType) {
      this._selectBusinessType.reset();
      this._selectBusinessType.select.closest('.form-group').classList.remove('form-group--error');
    }
    this._brandCategorySelectorCompany.value = null;
    this._brandCategorySelectorCompany.main.closest('.form-group').classList.remove('form-group--error');
    this._inputBusinessFirstName.value = '';
    this._inputBusinessFirstName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputBusinessLastName.value = '';
    this._inputBusinessLastName.input.closest('.form-group').classList.remove('form-group--error');
    this._inputBusinessEmail.value = '';
    this._inputBusinessEmail.input.closest('.form-group').classList.remove('form-group--error');
    this._inputBusinessTelephone.value = '';
    this._inputBusinessTelephone.input.closest('.form-group').classList.remove('form-group--error');

    this._showStep('intro');
    this.cancelBtns.forEach(b => b.classList.remove('d-none'));
  }

  _setForm(values) {
    this._id = values.id;
    if (values.typeClient === 'individual') {
      this._inputIndividualCompanyName.value = values.companyName;
      this._inputIndividualProductName.value = values.productName;
      this._inputIndividualCategory.value = values.brandCategoryId;
      this._inputIndividualFirstName.value = values.firstName;
      this._inputIndividualLastName.value = values.lastName;
      this._inputIndividualEmail.value = values.email;
      this._inputIndividualTelephone.value = values.telephone;
      this._inputEin.value = values.ein || '';
    } else {
      this._inputBusinessCompanyName.value = values.companyName;
      this._selectBusinessType.value = values.typeClient || '';
      this._brandCategorySelectorCompany.value = values.brandCategoryId;
      this._inputBusinessFirstName.value = values.firstName;
      this._inputBusinessLastName.value = values.lastName;
      this._inputBusinessEmail.value = values.email;
      this._inputBusinessTelephone.value = values.telephone;
      this._inputEin.value = values.ein || '';
    }
  }

  // Individual form validation
  _validateIndividualForm() {
    let ok = true;
    if (this._inputIndividualCompanyName.isEmpty) {
      ok = false;
      this._inputIndividualCompanyName.error = true;
    } else if (!this._inputIndividualCompanyName.isValidNameNoAccents) {
      ok = false;
      this._inputIndividualCompanyName.errorMessage = '*Invalid name format';
      this._inputIndividualCompanyName.error = true;
    } else {
      this._inputIndividualCompanyName.error = false;
    }

    if (this._inputIndividualProductName.isEmpty) {
      ok = false;
      this._inputIndividualProductName.error = true;
    } else if (!this._inputIndividualProductName.isValidNameNoAccents) {
      ok = false;
      this._inputIndividualProductName.errorMessage = '*Invalid name format';
      this._inputIndividualProductName.error = true;
    } else {
      this._inputIndividualProductName.error = false;
    }
    if (!this._inputIndividualCategory.value) {
      ok = false;
      this._inputIndividualCategory.main.closest('.form-group').classList.add('form-group--error');
    } else {
      this._inputIndividualCategory.main.closest('.form-group').classList.remove('form-group--error');
    }
    [['FirstName', 'isValidName'], ['LastName', 'isValidName'], ['Email', 'isValidEmail'], ['Telephone', v => v.length >= 10]]
      .forEach(([field, validator]) => {
        const input = this[`_inputIndividual${field}`];
        const valid = typeof validator === 'function' ? validator(input.value) : input[validator];
        if (input.isEmpty || !valid) {
          ok = false;
          input.errorMessage = '*Required';
          input.error = true;
        } else {
          input.error = false;
        }
      });
    return ok;
  }

  // Business form validation
  _validateBusinessForm() {
    let ok = true;
    if (this._inputBusinessCompanyName.isEmpty) {
      ok = false;
      this._inputBusinessCompanyName.error = true;
    } else if (!this._inputBusinessCompanyName.isValidNameNoAccents) {
      ok = false;
      this._inputBusinessCompanyName.errorMessage = '*Invalid name format';
      this._inputBusinessCompanyName.error = true;
    } else {
      this._inputBusinessCompanyName.error = false;
    }
    if(this._inputEin.isEmpty){
      ok = false;
      this._inputEin.errorMessage = '*Required';
      this._inputEin.error = true;
    }
    if (!this._selectBusinessType.value) {
      ok = false;
      this._selectBusinessType.select.closest('.form-group').classList.add('form-group--error');
    } else {
      this._selectBusinessType.select.closest('.form-group').classList.remove('form-group--error');
    }
    [['FirstName', 'isValidName'], ['LastName', 'isValidName'], ['Email', 'isValidEmail'], ['Telephone', v => v.length >= 10]]
      .forEach(([field, validator]) => {
        const input = this[`_inputBusiness${field}`];
        const valid = typeof validator === 'function' ? validator(input.value) : input[validator];
        if (input.isEmpty || !valid) {
          ok = false;
          input.errorMessage = '*Required';
          input.error = true;
        } else {
          input.error = false;
        }
      });
    return ok;
  }
  
  _validateBusinessBrandForm(){
    let ok = true;
    if (this._inputCompanyName.isEmpty) {
      ok = false;
      this._inputCompanyName.error = true;
    } else if (!this._inputCompanyName.isValidNameNoAccents) {
      ok = false;
      this._inputCompanyName.errorMessage = '*Invalid name format';
      this._inputCompanyName.error = true;
    } else {
      this._inputCompanyName.error = false;
    }
    
    if (!this._inputSelectCompany.value) {
      ok = false;
      this._inputSelectCompany.select.closest('.form-group').classList.add('form-group--error');
    } else {
      this._inputSelectCompany.select.closest('.form-group').classList.remove('form-group--error');
    }
    
    if (!this._brandCategorySelectorCompany.value) {
      ok = false;
      this._brandCategorySelectorCompany.main.closest('.form-group').classList.add('form-group--error');
    } else {
      this._brandCategorySelectorCompany.main.closest('.form-group').classList.remove('form-group--error');
    }
    
    return ok;
  }

  _validateForm() {
    const step = this.activeStep;
    if (step === 'individualForm') return this._validateIndividualForm();
    if (step === 'businessNewCompanyForm') return this._validateBusinessForm();
    if(step === 'businessSelectCompany') return this._validateBusinessBrandForm();
    return true;
  }

  _disabledCurrentForm(condition){
    const step = this.activeStep;
    const parentContainer = this.main.querySelector('[data-step="'+step+'"]');
    const formInputs = parentContainer.querySelectorAll('input');
    const formSelect = parentContainer.querySelectorAll('.select-custom');
    const formSelectCategory = parentContainer.querySelectorAll('.brand-selector');
    if(condition){
      if(formInputs.length>0){
        formInputs.forEach((input)=>{input.setAttribute('disabled',true)});
      }
      if(formSelect.length>0){
        formSelect.forEach((select)=>{select.classList.add('select-custom--disabled')});
      }
      if(formSelectCategory.length>0){
        formSelectCategory.forEach((select)=>{select.classList.add('brand-selector--disabled')});
      }
    }else{
      if(formInputs.length>0){
        formInputs.forEach((input)=>{input.removeAttribute('disabled')});
      }
      if(formSelect.length>0){
        formSelect.forEach((select)=>{select.classList.remove('select-custom--disabled')});
      }
      if(formSelectCategory.length>0){
        formSelectCategory.forEach((select)=>{select.classList.remove('brand-selector--disabled')});
      }
    }
  }

  _onSubmit(e) {
    e.preventDefault();
    let btn = e.currentTarget;
    if (this._sending) return;
    btn.classList.add('button--loading');
    this._disabledCurrentForm(true);

    const step = this.activeStep;
    let valid = this._validateForm();
    if (!valid) {
      btn.classList.remove('button--loading');
      this._disabledCurrentForm(false);
      return;
    }
    let payload;
    if (step === 'individualForm') {
      payload = {
        organization_name: this._inputIndividualCompanyName.value,
        brand_name: this._inputIndividualProductName.value,
        brand_category_id: this._inputIndividualCategory.value,
        customer: {
          type: 'individual',
          company_name: this._inputIndividualCompanyName.value,
          product_name: this._inputIndividualProductName.value,
          first_name: this._inputIndividualFirstName.value,
          last_name: this._inputIndividualLastName.value,
          email: this._inputIndividualEmail.value,
          phone: this._inputIndividualTelephone.value
        }
      };
    } else if(step == 'businessNewCompanyForm'){
      payload = {
        organization_name: this._inputBusinessCompanyName.value,
        type: this._selectBusinessType.value,
        first_name: this._inputBusinessFirstName.value,
        last_name: this._inputBusinessLastName.value,
        email: this._inputBusinessEmail.value,
        phone: this._inputBusinessTelephone.value,
        tax_id: this._inputEin.value
      };
    } else{
      payload = [{
        name: this._inputCompanyName.value,
        brand_category_id: this._brandCategorySelectorCompany.value,
      }];
    }

    this._sending = true;
    let action;
    if (step === 'individualForm') {
      action = this._id ? Brands.updateClient(this._id, payload) : Brands.createClient(payload);
    }else if( step === 'businessNewCompanyForm' ){
      action = this._id ? Organizations.updateOrganization(this._id, payload) : Organizations.createOrganization(payload);
    }else{
      action = this._id ? Organizations.updateOrganizationBrand : Organizations.createOrganizationBrand(this._inputSelectCompany.value,payload);
    }
    action.then(() => {
        this._sending = false;
        btn.classList.remove('button--loading');
        this._disabledCurrentForm(false);
        Notification.show(
          `Client ${this._id ? 'updated' : 'added'}`,
          'done'
        );
        const eventName = this._id ? 'updateClient' : 'createClient';
        if(step === 'businessNewCompanyForm'){
          this._setOrganizationSelect();
          this._showStep('businessSelectCompany');
        }
        if(step === 'businessSelectCompany'){
          this._setOrganizationSelect();
          this.hide();
        }
        this.main.dispatchEvent(new CustomEvent(eventName));
      })
      .catch(error => {
        this._sending = false;
        btn.classList.remove('button--loading');
        this._disabledCurrentForm(false);
        if (error && error.code === '002') {
          this._inputEin.error = true;
          this._inputEin.errorMessage = 'The client with that EIN already exists';
        } else {
          this.hide();
          Alert.show(
            'warning',
            'Something went wrong, please try again later.',
            null,
            'Ok'
          );
        }
      });
  }

  addEventListener(event, callback) {
    this.main.addEventListener(event, callback);
  }
}

export default ModalNewClient;
